import { render, staticRenderFns } from "./OnboardLayout.vue?vue&type=template&id=081c40ec"
import script from "./OnboardLayout.vue?vue&type=script&lang=js"
export * from "./OnboardLayout.vue?vue&type=script&lang=js"
import style0 from "./OnboardLayout.vue?vue&type=style&index=0&id=081c40ec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports